// extracted by mini-css-extract-plugin
module.exports = {"aboutButtonContainer":"_1M6lLJAX1jUfjIlzuSGD6Y","buttonGreen":"_3zgkYqortAX6_jeU8x_3__"};